import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "./../../../../../environments/environment";
import { GenericHttpService } from "./../../../services/generic-http.service";
import { Observable } from "rxjs";
import { GenericUtils } from './../../../utilities/generic-utils';

const genericUtils = new GenericUtils();
@Injectable({
  providedIn: 'root'
})
export class DataService {
  baseUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService, public utils: GenericUtils) { }

  getData(url, config, params): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${url}`,
      query: params
    };

    const functionToExecute = this[config['functionToCall']].bind(this);
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(functionToExecute)
    );
  }

  processInboundRegionSLA(data) {
    if (!Object.keys(data.data).length) return null;
    let quantity_sla = [],
    stocked_quantity = [],
      labels = [], originalData = data.data[0][Object.keys(data.data[0])[0]];
    let returnNull = false;

    originalData.forEach(ele => {
      if (ele["destination_region"] !== "Total" ){ //&& ele["destination_region"] !== "NA") {
        labels.push(ele["destination_region"]);
        quantity_sla.push(Number(ele.sla.toFixed(2)) || 0);
        stocked_quantity.push(Number(ele["stocked_quantity"].toFixed(2)) || 0)
      } else {
        if (ele["eligible_quantity"] === 0 && ele["stocked_quantity"] === 0) returnNull = true;
      }
    });
    if (quantity_sla.length > 10) quantity_sla = quantity_sla.slice(0, 9)

    return returnNull ? null : { labels, values: [quantity_sla, stocked_quantity] };
  }

  processOutboundRegionSLA(data) {
    if (!Object.keys(data.data).length) return null;
    let quantity_sla = [],
      shipped_quantity = [],
      labels = [], originalData = data.data[0][Object.keys(data.data[0])[0]];
    let returnNull = false;

    originalData.forEach(ele => {
      if (ele["origin_region"] !== "Total"){ // && ele["origin_region"] !== "NA") {
        labels.push(ele["origin_region"]);
        quantity_sla.push(Number(ele.sla.toFixed(2)) || 0);
        shipped_quantity.push(Number(ele["shipped_quantity"].toFixed(2)) || 0)
      } else {
        if (ele["eligible_quantity"] === 0 && ele["shipped_quantity"] === 0) returnNull = true;
      }
    });
    if (quantity_sla.length > 10) quantity_sla = quantity_sla.slice(0, 9)

    return returnNull ? null : { labels, values: [quantity_sla, shipped_quantity] };
  }


  createChart(chartData, chartOptions) {
    const chart = this.utils.deepCopyFunction(chartOptions[0]);
    chart.xAxis.categories = chartData.labels;
    for (let i = 0; i < chart.series.length; i++) {
      chart.series[i].data = chartData.values[i];
    }
    return chart;
  }
}
